import Main from "../../pages/Main.vue";
import PageName from "../../constant/PageName";
import PermissionIds from "../../constant/PermissionIds";
// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: "/business",
    icon: "md-list",
    name: "business",
    title: "平台业务",
    component: Main,
    children: [
      /** 垃圾袋入库统计部分 **/
      // {
      //       path: 'garbageBagCount',
      //       title: '垃圾袋入库统计',
      //       name: PageName.PAGE_BUSINESS_GARBAGEBAGCOUNT,
      //       // permissionId:PermissionIds.PERMISSION_BUSINESS_GARBAGEBAGCOUNT,
      //       component: function(resolve) { require(['../../pages/business/garbageBagCount/GarbageBagCount.vue'], resolve) },
      //    },
      {
        path: "rank",
        title: "排名信息",
        name: PageName.PAGE_BUSINESS_RANK_INFO,
        permissionId: PermissionIds.PERMISSION_BUSINESS_RANK,
        component: function(resolve) {
          require(["../../pages/business/rank/Rank.vue"], resolve);
        }
      },
      /** 照片审核部分 **/
      {
        path: "photoExamine",
        title: "照片审核",
        name: PageName.PAGE_BUSINESS_PHOTOEXAMINE,
        permissionId: PermissionIds.PERMISSION_BUSINESS_PHOTOEXAMINE,
        component: function(resolve) {
          require([
            "../../pages/business/photoExamine/PhotoExamine.vue"
          ], resolve);
        }
      },
      /** 可回收预约部分 **/
      {
        path: "appointmentRecovery",
        title: "可回收预约",
        name: PageName.PAGE_BUSINESS_APPOINTMENTRECOVERY,
        permissionId: PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERY,
        component: function(resolve) {
          require([
            "../../pages/business/appointmentRecovery/AppointmentRecovery.vue"
          ], resolve);
        }
      },
      /** 家宴预约 **/
      {
        path: "familyAppointment",
        title: "家宴预约",
        name: PageName.PAGE_BUSINESS_FAMILYAPPIONTMENT,
        permissionId: PermissionIds.PERMISSION_BUSINESS_FAMILYAPPIONTMENT,
        component: function(resolve) {
          require([
            "../../pages/business/familyAppointMent/FamilyAppointMent.vue"
          ], resolve);
        }
      },
      /** 督查员工作部分 **/
      {
        path: "inspector",
        title: "督查员工作",
        name: PageName.PAGE_BUSINESS_INSPECTOR,
        permissionId: PermissionIds.PERMISSION_BUSINESS_INSPECTOR,
        component: function(resolve) {
          require(["../../pages/business/Inspector/Inspector.vue"], resolve);
        }
      },
      /** collector部分 **/
      {
        path: "collector",
        title: "收集员工作",
        name: PageName.PAGE_BUSINESS_COLLECTOR,
        permissionId: PermissionIds.PERMISSION_BUSINESS_COLLECTOR,
        component: function(resolve) {
          require(["../../pages/business/collector/Collector.vue"], resolve);
        }
      },
      /** 审核员工作部分 **/
      {
        path: "auditor",
        title: "审核员工作",
        name: PageName.PAGE_BUSINESS_AUDITOR,
        permissionId: PermissionIds.PERMISSION_BUSINESS_AUDITOR,
        component: function(resolve) {
          require(["../../pages/business/auditor/Auditor.vue"], resolve);
        }
      },

      /** 亭长签到 **/
      {
        path: "pavilionSignIn",
        title: "亭长签到",
        name: PageName.PAGE_BUSINESS_PAVILIONTOWN,
        permissionId: PermissionIds.PERMISSION_BUSINESS_PAVILIONTOWN,
        component: function(resolve) {
          require([
            "../../pages/business/pavilionSignIn/pavilionTown.vue"
          ], resolve);
        }
      },

      /** 垃圾房管理部分 **/
      {
        path: "garbageRoom",
        title: "垃圾房管理",
        name: PageName.PAGE_BUSINESS_GARBAGEROOM,
        permissionId: PermissionIds.PERMISSION_BUSINESS_GARBAGEROOM,
        component: function(resolve) {
          require([
            "../../pages/business/garbageRoom/GarbageRoom.vue"
          ], resolve);
        }
      },
      {
        path: "garbageBagManage",
        title: "垃圾袋管理",
        name: PageName.PAGE_BUSINESS_GARBAGEBAGMANAGE,
        permissionId: PermissionIds.PERMISSION_BUSINESS_GARBAGEBAGMANAGE,
        component: function(resolve) {
          require([
            "../../pages/business/garbageBagManage/GarbageBagManage.vue"
          ], resolve);
        }
      },
      /** 垃圾汇总 **/
      {
        path: "garbageTotal",
        title: "垃圾汇总",
        name: PageName.PAGE_BUSINESS_GARBAGETOTAL,
        permissionId: PermissionIds.PERMISSION_BUSINESS_GARBAGETOTAL,
        component: function(resolve) {
          require([
            "../../pages/business/garbageTotal/GarbageTotal.vue"
          ], resolve);
        }
      },
      /** 易腐处理站部分 **/
      {
        path: "perishableStation",
        title: "易腐处理站",
        name: PageName.PAGE_BUSINESS_PERISHABLESTATION,
        permissionId: PermissionIds.PERMISSION_BUSINESS_PERISHABLESTATION,
        component: function(resolve) {
          require([
            "../../pages/business/perishableStation/PerishableStation.vue"
          ], resolve);
        }
      },
      /** 定时订点投放小区 **/
      {
        path: "Delivery",
        title: "定时定点投放小区",
        name: PageName.PAGE_BUSINESS_DELIVERY,
        permissionId: PermissionIds.PERMISSION_BUSINESS_DELIVERY,
        component: function(resolve) {
          require(["../../pages/business/delivery/Delivery.vue"], resolve);
        }
      },
      /** 暗访督查部分 **/
      {
        path: "secretInspection",
        title: "暗访督查",
        name: PageName.PAGE_BUSINESS_SECRETINSPECTION,
        permissionId: PermissionIds.PERMISSION_BUSINESS_SECRETINSPECTION,
        component: function(resolve) {
          require([
            "../../pages/business/secretInspection/SecretInspection.vue"
          ], resolve);
        }
      },
      /** 积分兑换统计部分 **/
      {
        path: "integralExchange",
        title: "积分兑换统计",
        name: PageName.PAGE_TRADEMANAGE_INTEGRALEXCHANGE,
        permissionId: PermissionIds.PERMISSION_TRADEMANAGE_INTEGRALEXCHANGE,
        component: function(resolve) {
          require([
            "../../pages/tradeManage/integralExchange/IntegralExchange.vue"
          ], resolve);
        }
      },
      /** 商户提现部分 **/
      {
        path: "withdrawal",
        title: "提现申请",
        name: PageName.PAGE_TRADEMANAGE_WITHDRAWAL,
        permissionId: PermissionIds.PERMISSION_TRADEMANAGE_WITHDRAWAL,
        component: function(resolve) {
          require([
            "../../pages/tradeManage/withdrawal/Withdrawal.vue"
          ], resolve);
        }
      },
      {
        path: "equipmentStatistics",
        title: "设备自查统计",
        name: PageName.PAGE_BUSINESS_EQUIPMENTSTATISTICS,
        permissionId: PermissionIds.PERMISSION_BUSINESS_EQUIPMENTSTATISTICS,
        component: function(resolve) {
          require([
            "../../pages/business/equipmentStatistics/EquipmentStatistics.vue"
          ], resolve);
        }
      },
      /** 自助回收审核 **/
      {
        path: "selfHelpRecovery",
        title: "自助回收审核",
        name: PageName.PAGE_BUSINESS_SELFHELPRECOVERY,
        permissionId: PermissionIds.PAGE_BUSINESS_SELFHELPRECOVERY,
        component: function(resolve) {
          require([
            "../../pages/business/selfhelpRecovery/SelfhelpRecovery.vue"
          ], resolve);
        }
      },
      /** 督导员打卡统计 **/
      {
        path: "supervisorPunchClock",
        title: "督导员打卡统计",
        name: PageName.PAGE_BUSINESS_SUPERVISORPUNCHLCLOCK,
        permissionId: PermissionIds.PAGE_BUSINESS_SUPERVISORPUNCHLCLOCK,
        component: function(resolve) {
          require([
            "../../pages/business/supervisorPunchClock/SupervisorPunchClock.vue"
          ], resolve);
        }
      },
      /** 巡查员打卡统计 **/
      {
        path: "inspectorPunchClock",
        title: "巡查员打卡统计",
        name: PageName.PAGE_BUSINESS_INSPECTORPUNCHCLOCK,
        permissionId: PermissionIds.PAGE_BUSINESS_INSPECTORPUNCHCLOCK,
        component: function(resolve) {
          require([
            "../../pages/business/inspectorPunchClock/InspectorPunchClock.vue"
          ], resolve);
        }
      },
      /** 清运人员打卡统计 **/
      {
        path: "pickupStaffPunchClock",
        title: "清运人员打卡统计",
        name: PageName.PAGE_BUSINESS_PICKUPSTAFFPUNCHCLOCK,
        permissionId: PermissionIds.PAGE_BUSINESS_PICKUPSTAFFPUNCHCLOCK,
        component: function(resolve) {
          require([
            "../../pages/business/pickupStaffPunchClock/PickupStaffPunchClock.vue"
          ], resolve);
        }
      },
      /** 设备打卡列表 **/
      {
        path: 'devicePunchClock',
        title: '设备打卡统计',
        name: PageName.PAGE_BUSINESS_DEVICEPUNCHCLOCK,
        // permissionId:PermissionIds.PAGE_BUSINESS_PICKUPSTAFFPUNCHCLOCK,
        component: function (resolve) { require(['../../pages/business/punchClock/DevicePunchClock.vue'], resolve) },
      },
      /** 公共环境检查统计部分 **/
      {
        path: "publicEnviromentCheck",
        title: "全域秀美统计",
        name: PageName.PAGE_BUSINESS_PUBLICENVIROMENTCHECK,
        //permissionId: PermissionIds.PERMISSION_BUSINESS_PUBLICENVIROMENTCHECK,
        component: function(resolve) {
          require([
            "../../pages/business/publicEnviromentCheck/PublicEnviromentCheck.vue"
          ], resolve);
        }
      },
      
    ]
  }
];

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: "/",
  name: "otherRouter",
  title: "首页",
  redirect: "/home",
  component: Main,
  children: [
    // { path: '/system/banner/add', title: '新增轮播图', name: PageName.PAGE_SYSTEM_BANNER_ADD, component: function(resolve) { require(['../../pages/system/banner/banner_add.vue'], resolve)} },
    // { path: '/system/banner/update', title: '修改轮播图', name: PageName.PAGE_SYSTEM_BANNER_UPDATE, component: function(resolve) { require(['../../pages/system/banner/banner_update.vue'], resolve)} },
    /** 可回收预约-管辖村级详情 **/

    {
      path: "appointmentRecoveryVillage",
      title: "管辖村级详情",
      name: PageName.PAGE_BUSINESS_APPOINTMENTRECOVERYVILLAGE,
      component: function(resolve) {
        require([
          "../../pages/business/appointmentRecoveryVillage/AppointmentRecoveryVillage.vue"
        ], resolve);
      }
    },
    /** 可回收预约-管辖用户详情 **/
    {
      path: "appointmentRecoveryUserDetail",
      title: "管辖用户详情",
      name: PageName.PAGE_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/appointmentRecoveryUserDetail/AppointmentRecoveryUserDetail.vue"
        ], resolve);
      }
    },
    /** 家宴预约 **/
    {
      path: "familyTown",
      title: "管辖乡村详情",
      name: PageName.PAGE_BUSINESS_FAMILYVILLAGE,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/familyAppointMent/FamilyVIllageAppointMent.vue"
        ], resolve);
      }
    },
    /** 家宴预约详情 **/
    {
      path: "familyAppointMentDetail",
      title: "管辖用户详情",
      name: PageName.PAGE_BUSINESS_FAMILYDETAIL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/familyAppointMent/FamilyAppointMentDetail.vue"
        ], resolve);
      }
    },
    {
      path: "InspectorDetail",
      title: "评分详细",
      name: PageName.PAGE_BUSINESS_INSPECTORDETAIL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/Inspector/InspectorDetail.vue"
        ], resolve);
      }
    },
    {
      path: "BusinessInspectorDetailList",
      title: "督查评分列表",
      name: PageName.PAGE_BUSINESS_INSPECTORDETAILLIST,
      component: function(resolve) {
        require([
          "../../pages/business/Inspector/InspectorDetailList.vue"
        ], resolve);
      }
    },
    {
      path: "InspectorDetailImg",
      title: "评分详情",
      name: PageName.PAGE_BUSINESS_INSPECTORDETAIL_IMG,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/Inspector/InspectorDetailImg.vue"
        ], resolve);
      }
    },
    {
      path: "InspectorMonthExport",
      title: "督查按周导出",
      name: PageName.PAGE_BUSINESS_INSPECTORMONTH_EXPORT,
      component: function(resolve) {
        require([
          "../../pages/business/Inspector/InspectorMonthExport.vue"
        ], resolve);
      }
    },
    {
      path: "CollectorDetail",
      title: "评分明细",
      name: PageName.PAGE_BUSINESS_COLLRCTORDETAIL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/collector/CollectorDetail.vue"
        ], resolve);
      }
    },
    {
      path: "CollectorDetailImg",
      title: "评分详情",
      name: PageName.PAGE_BUSINESS_COLLRCTORDETAIL_IMG,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/collector/CollectorDetailImg.vue"
        ], resolve);
      }
    },
    /** 亭长签到--乡村 **/
    {
      path: "pavilionVillage",
      title: "乡镇",
      name: PageName.PAGE_BUSINESS_PAVILIONVVILLAGE,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/pavilionSignIn/pavilionVillage.vue"
        ], resolve);
      }
    },
    /** 亭长签到--点 **/
    {
      path: "pavilionSpot",
      title: "乡村",
      name: PageName.PAGE_BUSINESS_PAVILIONSPOT,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/pavilionSignIn/pavilionSpot.vue"
        ], resolve);
      }
    },
    /** 亭长签到--签到日历 **/
    {
      path: "pavillionSignIn",
      title: "签到日历",
      name: PageName.PAGE_BUSINESS_PAVILIONTOWN_SIGNIN,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/pavilionSignIn/pavillionSignIn.vue"
        ], resolve);
      }
    },
    /** 亭长签到 **/
    {
      path: "pavillionMap",
      title: "亭长签到详情",
      name: PageName.PAGE_BUSINESS_PAVILION_MAP,
      component: function(resolve) {
        require([
          "../../pages/business/pavilionSignIn/pavillionMap.vue"
        ], resolve);
      }
    },
    /** 垃圾房管理--按月查询 **/
    {
      path: "GarbageMonth",
      title: "按月查询",
      name: PageName.PAGE_BUSINESS_GARBAGEROOM_MONTH,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require(["../../pages/business/garbageRoom/GarbageMonth.vue"], resolve);
      }
    },
    /** 垃圾房管理--乡村 **/
    {
      path: "GarbageRoomVillage",
      title: "所属垃圾站",
      name: PageName.PAGE_BUSINESS_GARBAGEROOM_VILLAGE,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageRoom/GarbageRoomVillage.vue"
        ], resolve);
      }
    },
    /** 垃圾房管理--签到日历 **/
    {
      path: "GarbageRommCalendar",
      title: "签到日历",
      name: PageName.PAGE_BUSINESS_GARBAGEROOM_CALENDAR,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageRoom/GarbageRommCalendar.vue"
        ], resolve);
      }
    },
    /** 垃圾房管理--地图 **/
    {
      path: "GarbageRoomMap",
      title: "签到详情",
      name: PageName.PAGE_BUSINESS_GARBAGEROOM_MAP,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageRoom/GarbageRoomMap.vue"
        ], resolve);
      }
    },
    /** 易腐处理站--入料统计 **/
    {
      path: "PerishableStationMaterial",
      title: "入料统计",
      name: PageName.PAGE_BUSINESS_PERISHABLESTATION_MATERIAL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/perishableStation/PerishableStationMaterial.vue"
        ], resolve);
      }
    },
    /** 易腐处理站--入料详情 **/
    {
      path: "MaterialDetail",
      title: "入料详情",
      name: PageName.PAGE_BUSINESS_MATERIALDETAIL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/perishableStation/MaterialDetail.vue"
        ], resolve);
      }
    },
    /** 易腐处理站--入料详情 **/
    {
      path: "GarbageTotalOther",
      title: "其他垃圾详情",
      name: PageName.PAGE_BUSINESS_GARBAGETOTAL_OTHER,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageTotal/GarbageTotalOther.vue"
        ], resolve);
      }
    },
    {
      path: "TownGarbageTotal",
      title: "镇垃圾统计",
      name: PageName.PAGE_BUSINESS_TOWN_GARBAGETOTAL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageTotal/TownGarbageTotal.vue"
        ], resolve);
      }
    },
    {
      path: "VillageGarbageTotal",
      title: "村垃圾统计",
      name: PageName.PAGE_BUSINESS_VILLAGE_GARBAGETOTAL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageTotal/VillageGarbageTotal.vue"
        ], resolve);
      }
    },
    {
      path: "GarbageTotalDetail",
      title: "垃圾统计详情",
      name: PageName.PAGE_BUSINESS_GARBAGETOTAL_DETAIL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageTotal/GarbageTotalDetail.vue"
        ], resolve);
      }
    },
    /** 易腐处理站--入料详情 **/
    {
      path: "GarbageTotalHarm",
      title: "有害垃圾详情",
      name: PageName.PAGE_BUSINESS_GARBAGETOTAL_HARM,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageTotal/GarbageTotalHarm.vue"
        ], resolve);
      }
    },
    /** 易腐处理站--入料详情 **/
    {
      path: "GarbageTotalBig",
      title: "大件垃圾详情",
      name: PageName.PAGE_BUSINESS_GARBAGETOTAL_BIG,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageTotal/GarbageTotalBig.vue"
        ], resolve);
      }
    },
    /** 易腐处理站--入料详情 **/
    {
      path: "Recyclable",
      title: "可回收详情",
      name: PageName.PAGE_BUSINESS_RECYCLABLE,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageTotal/Recyclable/Recyclable.vue"
        ], resolve);
      }
    },
    /** 易腐处理站--入料详情 **/
    {
      path: "RecyclableDetail",
      title: "废品类别汇总",
      name: PageName.PAGE_BUSINESS_RECYCLABLEDETAIL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageTotal/Recyclable/RecyclableDetail.vue"
        ], resolve);
      }
    },
    /** 易腐处理站--入料详情 **/
    {
      path: "RecyclableDetailInfo",
      title: "回收详情",
      name: PageName.PAGE_BUSINESS_RECYCLABLEDETAIL_INFO,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageTotal/Recyclable/RecyclableDetailInfo.vue"
        ], resolve);
      }
    },
    /** 垃圾袋管理--村 **/
    {
      path: "GarbageBagVillage",
      title: "管辖乡镇详情",
      name: PageName.PAGE_BUSINESS_GARBAGEBAGMANAGE_VILLAGE,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageBagManage/GarbageBagVillage.vue"
        ], resolve);
      }
    },
    /** 垃圾袋管理--村 **/
    {
      path: "GarbageBagArea",
      title: "管辖村详情",
      name: PageName.PAGE_BUSINESS_GARBAGEBAGMANAGE_AREA,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageBagManage/GarbageBagArea.vue"
        ], resolve);
      }
    },
    /** 垃圾袋管理--村 **/
    {
      path: "GarbageBagAreaDetail",
      title: "管辖片区详情",
      name: PageName.PAGE_BUSINESS_GARBAGEBAGMANAGE_AREADETAIL,
      // permissionId:PermissionIds.PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/garbageBagManage/GarbageBagAreaDetail.vue"
        ], resolve);
      }
    },
    {
      path: "DeliveryVillage",
      title: "入料统计",
      name: PageName.PAGE_BUSINESS_DELIVERYVILLAGE,
      component: function(resolve) {
        require(["../../pages/business/delivery/DeliveryVillage.vue"], resolve);
      }
    },
    {
      path: "DeliveryDetail",
      title: "入料个人明细",
      name: PageName.PAGE_BUSINESS_DELIVERYVILLAGE_DETAIL,
      component: function(resolve) {
        require(["../../pages/business/delivery/DeliveryDetail.vue"], resolve);
      }
    },
    {
      path: "EquipmentStatisticsDetail",
      title: "统计详情",
      name: PageName.PAGE_BUSINESS_EQUIPMENTSTATISTICS_DETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/equipmentStatistics/EquipmentStatisticsDetail.vue"
        ], resolve);
      }
    },
    {
      path: "EquipmentStatisticsImg",
      title: "附件详情",
      name: PageName.PAGE_BUSINESS_EQUIPMENTSTATISTICS_IMG,
      component: function(resolve) {
        require([
          "../../pages/business/equipmentStatistics/EquipmentStatisticsImg.vue"
        ], resolve);
      }
    },
    {
      path: "TownGarbageStatistic",
      title: "镇统计",
      name: PageName.PAGE_BUSINESS_TOWNGARBAGESTATISTIC,
      component: function(resolve) {
        require([
          "../../pages/business/perishableStation/TownGarbageStatistic.vue"
        ], resolve);
      }
    },
    {
      path: "SupervisorPunchClockDetail",
      title: "打卡详情",
      name: PageName.PAGE_BUSINESS_SUPERVISORPUNCHLCLOCKDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/supervisorPunchClock/SupervisorPunchClockDetail.vue"
        ], resolve);
      }
    },
    {
      path: "InspectorPunchClockStaticDetail",
      title: "打卡统计详情",
      name: PageName.PAGE_BUSINESS_INSPECTORPUNCHCLOCKSTATICDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/inspectorPunchClock/InspectorPunchClockStaticDetail.vue"
        ], resolve);
      }
    },
    {
      path: "InspectorPunchClockDetail",
      title: "打卡详情",
      name: PageName.PAGE_BUSINESS_INSPECTORPUNCHCLOCKDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/inspectorPunchClock/InspectorPunchClockDetail.vue"
        ], resolve);
      }
    },
    {
      path: "PickupStaffPunchClockDetail",
      title: "打卡详情",
      name: PageName.PAGE_BUSINESS_PICKUPSTAFFPUNCHCLOCKDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/pickupStaffPunchClock/PickupStaffPunchClockDetail.vue"
        ], resolve);
      }
    },
    {
      path: "DevicePunchClockDetail",
      title: "打卡详情",
      name: PageName.PAGE_BUSINESS_PUNCHCLOCKDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/punchClock/PunchClockDetail.vue"
        ], resolve);
      }
    },
    {
      path: "PublicEnviromentCheckDetail",
      title: "检查明细",
      name: PageName.PAGE_BUSINESS_PUBLICENVIROMENTCHECKDETAIL,
      component: function(resolve) {
        require([
          "../../pages/business/publicEnviromentCheck/PublicEnviromentCheckDetail.vue"
        ], resolve);
      }
    },
    {
      path: "PublicEnviromentCheckMap",
      title: "详细信息",
      name: PageName.PAGE_BUSINESS_PUBLICENVIROMENTCHECK_MAP,
      component: function(resolve) {
        require([
          "../../pages/business/publicEnviromentCheck/PublicEnviromentCheckMap.vue"
        ], resolve);
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/routers/B_BusinessRouter.js